module.exports = __webpack_public_path__ + "static/media/nike-never-ask-shengeliya.2fd6d24b.mp4";